import { BaseModal } from "../BaseModal";
import { ModalSize } from "../BaseModal/types";

const message = "Do you confirm you want to update this asset? Once this update is done, you can't roll it back.";
const title = "Save Changes";

import styles from "./confirmActionModal.module.css";

interface ChangesConfirmedModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

interface ModalActionsProps {
  onCancel: () => void;
  onContinue: () => void;
}

function ModalActions({ onCancel, onContinue }: Readonly<ModalActionsProps>) {
  return (
    <div className={styles.modalActions}>
      <button onClick={onCancel}>Cancel</button>
      <button onClick={onContinue}>Continue</button>
    </div>
  );
}

export default function ChangesConfirmedModal({ open, onClose, onContinue }: Readonly<ChangesConfirmedModalProps>) {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={title}
      size={ModalSize.SM}
      clickOutside
      slots={{
        bottomActions: <ModalActions onCancel={onClose} onContinue={onContinue} />,
      }}
    >
      <p className={styles.message}>{message}</p>
    </BaseModal>
  );
}
